import { Link } from 'react-router-dom'
import { DashboardPage } from './DashboardPage'
import { useWorkspace } from '../workspace/WorkspaceContext'
import { BrandLogo, useCompanyBrandScope } from '../branding/CompanyBranding'
import './clientHome.css'

export function ClientHomePage() {
  const workspace = useWorkspace()
  useCompanyBrandScope(workspace.companyId)
  if (workspace.loading) return <div className="boot" role="status">Carregando sua empresa…</div>
  if (workspace.error) return <div role="alert">{workspace.error}<button onClick={() => void workspace.reload()}>Tentar novamente</button></div>
  return <section className="client-home" aria-label="Início">
    <BrandLogo className="client-home-logo" compact />
    {workspace.companies.length > 1 && <label>Empresa<select value={workspace.companyId} onChange={event => workspace.selectCompany(event.target.value)}>{workspace.companies.map(company => <option key={company.id} value={company.id}>{company.tradeName}</option>)}</select></label>}
    <DashboardPage />
    <div className="client-home-cards">
      <Link to="/central/transmissao"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="13" height="14" rx="3"/><path d="m16 10 5-3v10l-5-3"/></svg><strong>Transmissão</strong><span>Veja suas câmeras ao vivo</span></Link>
      <Link to="/central/gravacoes"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="m10 8 6 4-6 4Z"/></svg><strong>Gravação</strong><span>Consulte seus vídeos gravados</span></Link>
      <Link to="/central/conta"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/></svg><strong>Perfil</strong><span>Cuide da sua conta</span></Link>
    </div>
  </section>
}
